import { ReservationDataService } from '@/common/services/details/details.service';
import { DetailsInterface } from '@/core/domain/details/models/details.model';
import { Component, OnInit } from '@angular/core';
import { isLiteReservation } from '@/common/utils/flow/type-flow.util';

@Component({
    selector: 'fe-reservation-parent',
    templateUrl: './reservation-parent.component.html',
    styleUrls: ['./reservation-parent.component.scss'],
})
export class ReservationParentComponent implements OnInit {
    reservationDetails: DetailsInterface | null = null;

    constructor(private reservationDataService: ReservationDataService) {}

    get isInternational(): boolean {
        const details = this.reservationDetails?.data?.reservationDetails;
        return !!details && details.currency !== 'MXN';
    }

    get isLite(): boolean {
        const details = this.reservationDetails?.data?.reservationDetails;
        if (!details || this.isInternational) {
            return false;
        }
        return isLiteReservation(
            details.typeFlow,
            (details.insurance ?? []).length,
        );
    }

    ngOnInit(): void {
        this.reservationDataService.getDetails().subscribe((details) => {
            this.reservationDetails = details;
        });
    }
}
